"use client"
import { useEffect } from "react"

export default function RevealInit() {
  useEffect(() => {
    // Opt IN to the hidden-then-fade state only once this component is running.
    // The CSS keeps .reveal visible until <html> has `js-reveal`, so a failed or
    // blocked JS chunk can no longer leave whole pages blank.
    document.documentElement.classList.add("js-reveal")
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.08, rootMargin: "0px 0px -48px 0px" }
    )

    function observe() {
      document.querySelectorAll(".reveal:not(.visible), .reveal-left:not(.visible), .reveal-right:not(.visible), .reveal-scale:not(.visible)").forEach(el => observer.observe(el))
    }

    observe()

    const mutation = new MutationObserver(observe)
    mutation.observe(document.body, { childList: true, subtree: true })

    return () => { observer.disconnect(); mutation.disconnect() }
  }, [])

  return null
}
